import styles from './Breadcrumb.module.scss';
import {useNavigate} from 'react-router-dom';
import {ReactComponent as ChevronIcon} from '../../assets/img/chevron-grey.svg';

type BreadcrumbProps = {
  linkList: {
    title: string;
    route?: string;
    active?: boolean;
  }[];
};

export function Breadcrumb({linkList}: BreadcrumbProps) {
  const navigate = useNavigate();

  const goToCreateJob = (route: string) => {
    navigate(route);
  };

  const listItems = linkList.map((item, index) => (
    <span key={`link-${index}`} className={styles.itemWrapper}>
      {index !== 0 && <ChevronIcon className={styles.arrowIcon} />}
      <span
        className={`${styles.linkItem} ${item.active ? styles.active : ''}`}
        onClick={() => {
          if (item.route) {
            goToCreateJob(item.route);
          }
        }}
      >
        {item.title}
      </span>
    </span>
  ));
  return <div className={styles.container}>{listItems}</div>;
}
